import angular from 'angular';
import uiRouter from 'angular-ui-router';

import TaxationSettingsComponent from './settings.component';

const taxationSettingsModule = angular.module('tinaba.components.taxation.settings', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('taxation.settings', {
      url: '/settings',
      template: '<taxation-settings></taxation-settings>'
    });
})

.component('taxationSettings', TaxationSettingsComponent);

export default taxationSettingsModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/taxation/settings/settings.js
 **/